import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const HelpSection = styled.div`
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${tokens.spacing.insetMedium};

  background: ${tokens.colors.yellow1};
  border-radius: ${tokens.radius.large};

  font-size: ${tokens.sizes.bodySmall}px;
  line-height: ${tokens.sizes.text}px;

  > span {
    margin-right: ${tokens.spacing.horizontalXsmall};
  }
`
